import { createAction } from '../../util/';

export const addToast = createAction('ADD_TOAST');
export const clearToast = createAction('CLEAR_TOAST', { noPayload: true });

const TIMEOUT = 1500;

export const showToast = data => dispatch => {
  dispatch(addToast(data));
  if (data.type !== 'error') {
    setTimeout(() => {
      dispatch(clearToast());
    }, TIMEOUT);
  } else if (data.error) {
    window.newrelic?.noticeError(data.error, { handled: true });
  }
};
